var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v("Permissions")]),
      _c(
        "w-list",
        _vm._l(_vm.admins, function (admin) {
          return _c(
            "w-list-item",
            { key: admin.id },
            [
              _c("w-list-item-text", [
                _vm._v(
                  " " + _vm._s(admin.name) + " (" + _vm._s(admin.email) + ") "
                ),
              ]),
              _c("w-list-item-text", [
                _vm._v(" " + _vm._s(_vm.adminPermissionsToString(admin)) + " "),
              ]),
              _c(
                "w-list-item-action",
                [
                  _c(
                    "w-button",
                    {
                      attrs: { disabled: admin.id == _vm.loggedInAdmin.id },
                      on: {
                        click: function ($event) {
                          return _vm.editAdmin(admin)
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "pen" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditAdmin != null } },
        [
          _vm.toEditAdmin
            ? _c(
                "w-card",
                { attrs: { "max-width": "700" } },
                [
                  _c("w-card-title", [_vm._v("Edit admin permissions")]),
                  _c(
                    "w-card-content",
                    _vm._l(_vm.availablePermissions, function (permission) {
                      return _c("w-checkbox", {
                        key: permission,
                        attrs: {
                          label: permission,
                          value: _vm.hasPermission(_vm.toEditAdmin, permission),
                        },
                        on: {
                          input: function ($event) {
                            return _vm.setPermission(
                              _vm.toEditAdmin,
                              permission,
                              $event
                            )
                          },
                        },
                      })
                    }),
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.cancel()
                            },
                          },
                        },
                        [_vm._v(" Cancel ")]
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [_vm._v(" Save ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }